import { render } from "./ProsesKomponen.vue?vue&type=template&id=4777d1a2"
import script from "./ProsesKomponen.vue?vue&type=script&lang=js"
export * from "./ProsesKomponen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__